import script from "./myfooter.vue?vue&type=script&setup=true&lang=js"
export * from "./myfooter.vue?vue&type=script&setup=true&lang=js"

import "./myfooter.vue?vue&type=style&index=0&id=498ae436&scoped=true&lang=less"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498ae436"]])

export default __exports__